import {Formik, Field} from 'formik'
import * as Yup from 'yup'
import {useState} from 'react'
import {Modal} from 'react-bootstrap'
import {GoogleReCaptchaCheckbox} from 'react-google-recaptcha-ultimate'
import InputMask from 'react-input-mask'

import {useContactForm} from '../context/useMutation'
import {useIntl} from 'react-intl'
import ControlledInput from 'src/feature/bite/component/ControlledInput'

export default function ContactUs({
  modal,
  setModal,
  merchantData,
}: {
  modal: boolean
  setModal: (modal: boolean) => void
  merchantData: {
    name: string
    surname: string
    email: string
    phone: string
  }
}) {
  const intl = useIntl()
  const {mutateAsync, isLoading} = useContactForm()

  const [modalSend, setModalSend] = useState(false)
  const [oldgoogleRecaptcha, setOldGoogleRecaptcha] = useState<string>('')

  const validSchema = Yup.object({
    firstName: Yup.string().required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    lastName: Yup.string().required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    emailAddress: Yup.string()
      .email(intl.formatMessage({id: 'GLOBAL.VALIDATION.EMAIL'}))
      .max(100, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 100}))
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    phoneNumber: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .matches(
        /^\+971 \(\d{3}\) \d{3}-\d{4}$/,
        intl.formatMessage({id: 'GLOBAL.VALIDATION.PHONE'})
      ),
    message: Yup.string()
      .max(400, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 400}))
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    recaptcha: Yup.string().required('Captcha is required'),
  })

  const handleSubmit = async (values) => {
    setOldGoogleRecaptcha(values.recaptcha)

    const response = await mutateAsync({
      values,
      recaptcha: oldgoogleRecaptcha,
    })

    if (response) {
      setModalSend(true)
    }

    if (typeof document !== 'undefined' && (window as any).grecaptcha) {
      ;(window as any).grecaptcha.reset()
    }
  }

  const handleExpired = (setFieldValue) => {
    setOldGoogleRecaptcha('')
    setFieldValue('recaptcha', '')
    if (typeof document !== 'undefined' && (window as any).grecaptcha) {
      ;(window as any).grecaptcha.reset()
    }
  }

  return (
    <Modal centered tabIndex='-1' show={modal} onHide={() => setModal(false)}>
      {modalSend ? (
        <>
          <Modal.Header>
            <Modal.Title>{intl.formatMessage({id: 'GLOBAL.CONTACT_US.THANK_YOU'})}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <h1 className='text-success'>
								</h1> */}
            <p>
              {/* We have received your message and will get back to you as soon as possible */}
              {intl.formatMessage({id: 'GLOBAL.CONTACT_US.THANK_YOU_DESC'})}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <button className='btn btn-primary' onClick={() => setModal(false)}>
              {/* Close */}
              {intl.formatMessage({id: 'GLOBAL.BUTTON.CLOSE'})}
            </button>
          </Modal.Footer>
        </>
      ) : (
        <>
          <Modal.Header>
            <Modal.Title>
              {/* Contact Us */}
              {intl.formatMessage({id: 'CONTACT_US'})}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className='p-4'>
            <Formik
              initialValues={{
                firstName: merchantData?.name,
                lastName: merchantData?.surname,
                emailAddress: merchantData?.email || '',
                phoneNumber: merchantData?.phone || '',
                message: '',
                recaptcha: '',
                source: 1,
              }}
              enableReinitialize
              validationSchema={validSchema}
              onSubmit={(values) => {
                handleSubmit(values)
              }}
            >
              {({setFieldValue, values, errors, touched, submitForm}) => {
                return (
                  <>
                    <div className='fv-row mb-8 form-floating'>
                      <ControlledInput
                        name='firstName'
                        className='form-control'
                        type='text'
                        id='firstName'
                        placeholder={intl.formatMessage({id: 'AUTH.BECOME_MEMBER.FIRST_NAME'})}
                        setFieldValue={setFieldValue}
                      />
                      <label>
                        {/* Name */}
                        {intl.formatMessage({id: 'AUTH.BECOME_MEMBER.FIRST_NAME'})}
                      </label>
                      {errors.firstName && touched.firstName ? (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{errors.firstName}</div>
                        </div>
                      ) : null}
                    </div>
                    <div className='fv-row mb-8 form-floating'>
                      <ControlledInput
                        name='lastName'
                        className='form-control'
                        type='text'
                        id='lastName'
                        placeholder={intl.formatMessage({id: 'AUTH.BECOME_MEMBER.LAST_NAME'})}
                        setFieldValue={setFieldValue}
                      />
                      <label>{intl.formatMessage({id: 'AUTH.BECOME_MEMBER.LAST_NAME'})}</label>
                      {errors.lastName && touched.lastName ? (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{errors.lastName}</div>
                        </div>
                      ) : null}
                    </div>
                    <div className='fv-row mb-8 form-floating'>
                      <Field
                        name='emailAddress'
                        className='form-control'
                        type='emailAddress'
                        maxLength={101}
                        placeholder={intl.formatMessage({id: 'AUTH.BECOME_MEMBER.EMAIL'})}
                      />
                      <label>{intl.formatMessage({id: 'AUTH.BECOME_MEMBER.EMAIL'})}</label>
                      {errors.emailAddress && touched.emailAddress ? (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{errors.emailAddress}</div>
                        </div>
                      ) : null}
                    </div>
                    <div className='fv-row mb-8 form-floating'>
                      {/* <Field
                          mask='+971 (999) 999-9999'
                          name='phoneNumber'
                          className='form-control'
                          type='phoneNumber'
                          placeholder='Phone'
                        /> */}
                      <InputMask
                        mask={'+\\9\\7\\1\\ 99 999 9999'}
                        name='phoneNumber'
                        className='form-control'
                        type='phoneNumber'
                        value={values.phoneNumber}
                        onChange={(e) => {
                          setFieldValue('phoneNumber', e.target.value)
                        }}
                      />
                      <label>{intl.formatMessage({id: 'AUTH.BECOME_MEMBER.PHONE'})}</label>
                      {errors.phoneNumber ? (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{errors.phoneNumber}</div>
                        </div>
                      ) : null}
                    </div>
                    <div className='fv-row mb-8 form-floating'>
                      <Field
                        as='textarea'
                        name='message'
                        className='form-control h-auto no-resize'
                        type='text'
                        placeholder={intl.formatMessage({id: 'AUTH.BECOME_MEMBER.MESSAGE'})}
                      />
                      <label>{intl.formatMessage({id: 'AUTH.BECOME_MEMBER.MESSAGE'})}</label>
                      {errors.message && touched.message ? (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{errors.message}</div>
                        </div>
                      ) : null}
                      {values.message.length > 400 && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            {/* Max 400 characters */}
                            {intl.formatMessage(
                              {id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'},
                              {length: 400}
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                    <GoogleReCaptchaCheckbox
                      action='CONTACT_US_FORM'
                      callback={(token) => {
                        setFieldValue('recaptcha', token)

                        setTimeout(() => {
                          handleExpired(setFieldValue)
                        }, 60000)
                      }}
                    />
                    {errors.recaptcha && touched.recaptcha ? (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{errors.recaptcha}</div>
                      </div>
                    ) : null}
                    <div className='d-flex justify-content-end'>
                      <button
                        className='btn btn-primary'
                        disabled={isLoading}
                        onClick={() => {
                          submitForm()
                        }}
                      >
                        {/* {isLoading ? 'Loading...' : 'Submit'} */}
                        {isLoading
                          ? intl.formatMessage({id: 'LOADING'})
                          : intl.formatMessage({id: 'GLOBAL.BUTTON.SUBMIT'})}
                      </button>
                    </div>
                  </>
                )
              }}
            </Formik>
          </Modal.Body>
        </>
      )}
    </Modal>
  )
}
